import { redirect } from "@tanstack/solid-router";

export const FEATURES = {
  auth:           import.meta.env.VITE_FEATURE_AUTH           !== "false",
  dashboard:      import.meta.env.VITE_FEATURE_DASHBOARD      !== "false",
  profile:        import.meta.env.VITE_FEATURE_PROFILE        !== "false",
  rankings:       import.meta.env.VITE_FEATURE_RANKINGS       !== "false",
  duels:          import.meta.env.VITE_FEATURE_DUELS          !== "false",
  tournaments:    import.meta.env.VITE_FEATURE_TOURNAMENTS    !== "false",
  reports:        import.meta.env.VITE_FEATURE_REPORTS        !== "false",
  admin:          import.meta.env.VITE_FEATURE_ADMIN          !== "false",
  matchHistory:   import.meta.env.VITE_FEATURE_MATCH_HISTORY  !== "false",
} as const;

export type FeatureKey = keyof typeof FEATURES;

export function requireFeature(key: FeatureKey): void {
  if (!FEATURES[key]) throw redirect({ to: "/" });
}

// Returns the first accessible route after login, or null if nothing is enabled.
export function firstEnabledRoute(username?: string): string | null {
  if (FEATURES.dashboard)            return "/dashboard";
  if (FEATURES.auth)                 return "/";
  if (FEATURES.rankings)             return "/rankings";
  if (FEATURES.profile && username)  return `/profile/${username}`;
  if (FEATURES.duels)                return "/duels";
  if (FEATURES.tournaments)          return "/tournaments";
  return null;
}
